<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css'

export default {
  name: 'App',
  components: {},
  created() {
    // 只有在当前路径不是登录页时才跳转到登录页
    if (this.$route.path !== '/login') {
      this.$router.push('/login')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

#app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

.el-container {
  margin: 0 !important;
  padding: 0 !important;
  height: 100% !important;
}

.el-aside {
  margin: 0 !important;
  padding: 0 !important;
}

.el-header {
  margin: 0 !important;
  padding: 0 !important;
}

.el-main {
  margin: 0 !important;
  padding: 0 !important;
}

.el-footer {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
